(ns hypnos.consumer.panels.consult.claustrophobia-level
  "The consult claustrophobia level (when wearing a mask) step."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:on-click (fn [_] (nav-fn state :claustrophobia-level :next))}
     (tr :ui.label/next)]]
   [:p.control
    [:button.button.is-rounded.is-light
     {:on-click (fn [_] (nav-fn state :claustrophobia-level :prev))}
     (tr :ui.label/prev)]]])

(defn- statement
  []
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.claustrophobia/statement)]]])

(defn claustrophobia-level-field
  [state]
  [:div.field.has-check
   [:div.field-label.is-normal
    [:label.label (str (tr :ui.survey.claustrophobia/question))]]
   [:div.field-body
    [:div.field
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "claustrophobia-level"
                      :checked   (= 1 (get-in @state [:consult :consult/claustrophobia-level :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/claustrophobia-level :value])
                                         new-value (when (-> e .-target .-checked) 1)
                                         changed?  (or (get-in @state [:consult :consult/claustrophobia-level :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/claustrophobia-level :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/claustrophobia-level :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/claustrophobia-level :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.claustrophobia-level/little)]]]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "claustrophobia-level"
                      :checked   (= 2 (get-in @state [:consult :consult/claustrophobia-level :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/claustrophobia-level :value])
                                         new-value (when (-> e .-target .-checked) 2)
                                         changed?  (or (get-in @state [:consult :consult/claustrophobia-level :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/claustrophobia-level :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/claustrophobia-level :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/claustrophobia-level :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.claustrophobia-level/severe)]]]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "claustrophobia-level"
                      :checked   (= 0 (get-in @state [:consult :consult/claustrophobia-level :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/claustrophobia-level :value])
                                         new-value (when (-> e .-target .-checked) 0)
                                         changed?  (or (get-in @state [:consult :consult/claustrophobia-level :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/claustrophobia-level :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/claustrophobia-level :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/claustrophobia-level :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.claustrophobia-level/none)]]]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "claustrophobia-level"
                      :checked   (= -1 (get-in @state [:consult :consult/claustrophobia-level :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/claustrophobia-level :value])
                                         new-value (when (-> e .-target .-checked) -1)
                                         changed?  (or (get-in @state [:consult :consult/claustrophobia-level :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/claustrophobia-level :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/claustrophobia-level :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/claustrophobia-level :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.claustrophobia-level/na)]]]]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The claustrophobia level step"
  [state nav-fn]
  [:div.card-content
   ;; statement
   [statement]
   ;; field
   [claustrophobia-level-field state]
   [:hr]
   ;; navigation
   [navigation state nav-fn]])
